import client from './client';

export function listBillings(params = {}) {
  return client.get('/billings/', { params });
}

export function submitMeterReading(data) {
  return client.post('/billings/meter-readings', data);
}

export function bulkUpsertMeterReadings(data) {
  return client.post('/billings/meter-readings/bulk-upsert', data);
}

export function generateBilling(data) {
  return client.post('/billings/generate', data);
}

export function approveBilling(id) {
  return client.post(`/billings/${id}/approve`);
}

export function distributeBilling(id) {
  return client.post(`/billings/${id}/distribute`);
}

export function downloadMeterReadingTemplate() {
  return client.get('/billings/meter-readings/template', {
    responseType: 'blob',
  });
}

export function generateMeterTemplate(data) {
  return client.post('/billings/meter-readings/generate-template', data, {
    responseType: 'blob',
  });
}

export function getMeterTemplateRoster(params = {}) {
  return client.get('/billings/meter-readings/template-roster', { params });
}

export function uploadMeterReadings(file) {
  const formData = new FormData();
  formData.append('file', file);
  return client.post('/billings/meter-readings/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function uploadDailyMeterSheet(file) {
  const formData = new FormData();
  formData.append('file', file);
  return client.post('/billings/meter-readings/upload-daily-sheet', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function validateMeterReadingTemplate(file) {
  const formData = new FormData();
  formData.append('file', file);
  return client.post('/billings/meter-readings/validate-template', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function validateDailySheetTemplate(file) {
  const formData = new FormData();
  formData.append('file', file);
  return client.post('/billings/meter-readings/validate-daily-sheet', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
}

export function listMeterReadings(params = {}) {
  return client.get('/billings/meter-readings', { params });
}

export function getDailyMeterGrid(params) {
  return client.get('/billings/meter-readings/daily-grid', { params });
}

export function previewBilling(data) {
  return client.post('/billings/preview', data);
}

export function getBillingImportStatus(params) {
  return client.get('/billings/import-status', { params });
}

// FIX-019 WP-8: Upload Monitor Dashboard API
export const listUploads = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v != null && v !== '') query.append(k, v); });
  return client.get(`/billing/uploads/?${query.toString()}`);
};

export const getUploadStats = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => { if (v != null && v !== '') query.append(k, v); });
  return client.get(`/billing/uploads/stats?${query.toString()}`);
};

export const getUploadDetail = (uploadId) => client.get(`/billing/uploads/${uploadId}`);
